import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {translations} from 'presentation/translations-new';
import {ChangeFlowVariantEnum} from '../../constants';
import {GetChangeFlowDialogDescriptionParams} from './types';

const {specialtyFlow, unitsFlow} = translations['pt-br'].privateFlow.bookingFlow;
const {city} = translations['pt-br'].privateFlow.profile.locationSelection;

const getChangeFlowDialogDescription = ({
	variant,
	flowType,
}: GetChangeFlowDialogDescriptionParams): {description: string} => {
	const isExamFlow = flowType === FlowEnum.EXAM;

	const contentMap: Record<ChangeFlowVariantEnum, {description: string}> = {
		[ChangeFlowVariantEnum.LOCATION]: {
			description: city.changeState.description,
		},
		[ChangeFlowVariantEnum.SPECIALTY]: {
			description: isExamFlow
				? specialtyFlow.changeState.examDescription
				: specialtyFlow.changeState.description,
		},
		[ChangeFlowVariantEnum.UNIT]: {
			description: unitsFlow.changeState.description,
		},
	};

	return contentMap[variant];
};

export {getChangeFlowDialogDescription};
